import { apiClient, type ShipmentCategoryExEntity } from '@/libs/api'

export type FetchShipmentCategoryQuery = {
  tenantKey: string
  shipmentCategoryId: number
}

export const fetchShipmentCategory = async (
  { tenantKey, shipmentCategoryId }: FetchShipmentCategoryQuery,
  signal?: AbortSignal
): Promise<ShipmentCategoryExEntity> => {
  const { data } = await apiClient
    ._tenant(tenantKey)
    .shipment_categories._id(shipmentCategoryId)
    .$get({
      config: {
        signal
      }
    })
  return data
}
